import React, { createContext, useContext, useState } from "react";
import SuccessModal from "../commons/succcess-modal";

const AppContext = createContext();

export function useAppContext() {
  const context = useContext(AppContext);
  if (context === undefined) {
    throw new Error("useAppContext must be used within an AppProvider");
  }
  return context;
}

const useSuccessModal = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [body, setBody] = useState("");
  const [header, setHeader] = useState("");
  const close = () => {
    setIsOpen(false);
    setBody("");
    setHeader("");
  }

  const open = (header, body) => {
    setHeader(header);
    setBody(body);
    setIsOpen(true);
  };

  return {
    isOpen,
    body,
    header,
    close,
    open
  };
};

export function AppProvider({ children }) {
  const successModal = useSuccessModal();
  const value = {
    successModal,
  };

  return (
    <AppContext.Provider value={value}>
      {children}
      <SuccessModal />
    </AppContext.Provider>
  );
}
